import { render, staticRenderFns } from "./label-production-modal.vue?vue&type=template&id=451fb2cc"
import script from "./label-production-modal.vue?vue&type=script&lang=js"
export * from "./label-production-modal.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports